export const makeSSOUrl = path => `${process.env.REACT_APP_SSO_URL || 'https://sso.grupounicad.com.br'}/${path}`;
